import { render } from "./PayTipsButton.vue?vue&type=template&id=daeceb1a&lang=pug"
import script from "./PayTipsButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PayTipsButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__